var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.svgIconComponent,{tag:"component",class:{ 'rtl-flip-icon': _vm.rtlFlip },style:({ fill: _vm.computedColor })})}
var staticRenderFns = []

export { render, staticRenderFns }